import axios from 'axios'
import { getURL } from '../utils.js'

export function API () {}

API.prototype.getURL = (path) => {
  return getURL(path)
}

API.prototype.Login = () => {
  window.location.href = getURL('/auth/login')
}

API.prototype.Logout = async () => {
  const url = getURL('/auth/logout')
  window.location.replace(url)
}

API.prototype.UserInfo = async () => {
  let result = {}
  const url = getURL('/auth/userinfo')
  await axios.get(url)
    .then(resp => {
      if (resp.data != null) {
        result = { claims: resp.data.IDTokenClaims }
      }
    })
    .catch(err => {
      console.log('[ERROR] GET /auth/userinfo', err.message)
    })
  return result
}

API.prototype.UserLocalRoles = async (username) => {
  let result = []
  let roles = {}
  if (!username) {
    return result
  }
  const path = '/ib/api/v1/settings/roles'
  const url = getURL(path)
  await axios.get(url, {withCredentials: true})
    .then(res => {
      if (res.data != null) {
        roles = res.data.roles
        Object.keys(roles).forEach(key => {
          const role = roles[key]
          if (Array.isArray(role) && role.includes(username)) {
            result.push(key)
          }
        })
      }
    })
    .catch(err => {
      console.log('[ERROR] GET ' + path, err.message)
    })
  return result
}

API.prototype.UploadImage = async (formData) => {
  const url = getURL('/private/upload/image/' + 'cm-instructions')
  const opt = { headers: { 'Content-Type': 'multipart/form-data' } }

  return axios.post(url, formData, opt)
}

API.prototype.DeleteImage = async (folder, filename) => {
  const url = getURL('/private/delete/image/' + encodeURIComponent(folder) + '/' + encodeURIComponent(filename))
  return axios.delete(url)
}

API.prototype.ssoHostURL = async () => {
  let result = {}
  const url = getURL('/about')
  await axios.get(url)
      .then(resp => {
        if (resp.data != null) {
          result = resp.data.ssoHost
        }
      })
      .catch(err => {
        console.log('[ERROR] GET /about', err.message)
      })
  return result
}